// import { ScrollSmoother } from "gsap/ScrollSmoother";

// let smoother = null;
// let currentScreenSize;

// $(window).resize(function () {
//     killSmoother();
//     createSmoother();
// })

// export function createSmoother() {
//     currentScreenSize = document.documentElement.clientWidth;
//     if (currentScreenSize >= 1081) {
//         if (!smoother) {
            
//             // let overscrollBehavior = currentScreenSize < 768 ? 'auto' : 'none';

//             smoother = ScrollSmoother.create({
//                 smooth: 1.2, // how long (in seconds) it takes to "catch up" to the native scroll position
//                 effects: true, // looks for data-speed and data-lag attributes on elements
//                 // smoothTouch: 0.2, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
//                 smoothTouch: false,
//                 ignoreMobileResize: false,
//                 normalizeScroll: true,
//                 // overscrollBehavior: overscrollBehavior,
//                 // speed: 1.5
//             });

//             document.querySelectorAll(".level-2-tabs").forEach(el => {
//                 el.addEventListener("touchstart", function (e) {
//                     e.stopPropagation(); // Prevent GSAP from overriding touch events
//                 });
//             });
//         }
//         return smoother;
//     } else {
//         pauseSmoother();
//     }
// }

// export function getSmoother() {
//     return smoother;
// }

// export function killSmoother() {
//     if (smoother) {
//         smoother.kill();
//         smoother = null;
//     }
// }

// export function pauseSmoother() {
//     if (smoother) {
//       smoother.paused(true);
//     }
// }

// export function resumeSmoother() {
//     if (smoother) {
//       smoother.paused(false);
//     }
// }